import { LaydownLogFormConfig} from '../../../../../../models/assets-data/laydown/LaydownLogFormConfig.interface';
/**
 * Default laydown log form configuration used as a fallback if fetching the laydown-log-form-config.json file fails.
 * 
 * - Defines form structure, input fields, validation rules, and default values.
 * - Ensures essential fields like Job Number, Contact, Space, and Storage Facility are properly configured.
 * - Supports different input types (text, number, date, select).
 * - Provides configuration for laydown space tracking.
 * 
 * This ensures the laydown log form remains functional even if dynamic configuration retrieval fails.
 */
export const DEFAULT_ASSETS_LAYDOWN_LOG_FORM: LaydownLogFormConfig = {
        laydownLogForm: {
          inputs: {
            jobNumber: {
              label: "Job Number",
              type: "input",
              placeholder: "Enter Job Number",
              required: true
            },
            contact: {
              label: "Contact",
              type: "input",
              placeholder: "Start typing to find email",
              required: true
            },
            space: {
              label: "Space",
              type: "input",
              placeholder: "Enter space location",
              required: true,
              options: [
                { value: "A", label: "A" },
                { value: "B", label: "B" },
             
              ]
            },
            storageFacility: {
              label: "Storage Facility",
              type: "input",
              disabled: true
            },
          

            dateIn: {
              label: "Date In",
              type: "date",
              placeholder: "MM/DD/YY",
              required: true
            },
            estDateOut: {
              label: "Estimated Date Out",
              type: "date",
              placeholder: "MM/DD/YY",
              required: true
            }
    
        
          },
          submitButtonText: "Submit Entry"
        }
      };
      